import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";
import { createSelector } from "reselect";
import { selectManagementReducer } from "./managementSelectors";

const selectSuppressionListReducer = createStatePropertySelector(selectManagementReducer("suppressionList"));

const selectLists = selectSuppressionListReducer("lists");

export const selectSuppressionLists = createSelector(selectLists, (lists) => (Array.isArray(lists) ? lists : []));

const selectSuppressionListParsing = selectSuppressionListReducer("parsing");
// Suppression List loading states
const selectIsListLoading = selectSuppressionListReducer("isLoading");
export const selectIsListReady = selectSuppressionListReducer("isReady");

// Suppression List errors
export const selectSuppressionListSendingError = selectSuppressionListReducer("sendingError");

const selectSuppressionListParsingError = createSelector(
    selectSuppressionListParsing,
    (parsing) => parsing.error,
);

export const selectIsSLHasError = createSelector(
    selectSuppressionListParsingError,
    ({ isOverTheLimit, notADomains, columnsNumber, format }) =>
        columnsNumber || isOverTheLimit || notADomains || format,
);

const selectSLErrorsObject = createSelector(
    selectSuppressionListParsingError,
    selectSuppressionListSendingError,
    ({ isOverTheLimit, notADomains, columnsNumber }, sendingError) => ({
        isOverTheLimit,
        notADomains,
        sendingError,
        columnsNumber,
    }),
);

export const selectListOwnedByCurrentUser = createSelector(selectSuppressionLists, (lists) =>
    lists ? lists.find((list) => list?.isOwnedByRequestedUser) : null,
);

export const selectHasListOwnedByCurrentUser = createSelector(selectListOwnedByCurrentUser, (list) => !!list);

export const selectIsLoadingLists = selectSuppressionListReducer("isLoading");

export const selectParsedDomains = createSelector(selectSuppressionListParsing, (parsing) => parsing.domains);
export const selectTotalParsedRowsCount = createSelector(
    selectSuppressionListParsing,
    (parsing) => parsing.totalRowsCount,
);

export const selectCreateListStep = selectSuppressionListReducer("createListStep");

export const selectParsingErrors = createSelector(
    selectSuppressionListParsingError,
    ({ isOverTheLimit, notADomains, columnsNumber, format }) => ({
        isOverTheLimit,
        notADomains,
        columnsNumber,
        format,
    }),
);
